import { withInstall } from '@lit-element/utils'
import TimeSelect from './src/time-select.vue'

import type { SFCWithInstall } from '@lit-element/utils'

export const LtTimeSelect: SFCWithInstall<typeof TimeSelect> =
  withInstall(TimeSelect)
export default LtTimeSelect

export * from './src/time-select'
